export interface PlanUpgradeContext {
  token: string;
  tenantSlug?: string;
  tenantId?: number;
  tenantName?: string;
  email?: string;
}

const STORAGE_KEY = 'planUpgradeContext';
const PLAN_UPGRADE_ENDPOINTS = [
  '/api/tenants/plan-usage',
  '/api/payments/me',
  '/api/payments/checkout'
];

export const savePlanUpgradeContext = (context: PlanUpgradeContext) => {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(context));
  } catch (error) {
    console.warn('Unable to persist plan upgrade context', error);
  }
};

export const getPlanUpgradeContext = (): PlanUpgradeContext | null => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (error) {
    console.warn('Unable to read plan upgrade context', error);
    return null;
  }
};

export const clearPlanUpgradeContext = () => {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    console.warn('Unable to clear plan upgrade context', error);
  }
};

export const shouldUsePlanUpgradeContext = (url?: string) => {
  if (!url) return false;
  return PLAN_UPGRADE_ENDPOINTS.some((endpoint) => url.includes(endpoint));
};
